const CACHE_KEY = "ab_login_logo_cache_v1";

/**
 * Cache local das logos/settings do login para exibir imediatamente
 * sem esperar a API (que costuma trazer base64 pesado).
 */
export function getCachedLoginSettings() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || (!parsed.logoLight && !parsed.logoDark)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setCachedLoginSettings(settings) {
  if (!settings) return false;

  const payload = {
    id: settings.id ?? null,
    siteName: settings.siteName ?? null,
    logoLight: settings.logoLight ?? null,
    logoDark: settings.logoDark ?? null,
    updatedAt: settings.updatedAt ?? null,
    cachedAt: Date.now(),
  };

  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
    return true;
  } catch {
    // Quota excedida: tenta limpar cache antigo e gravar de novo
    try {
      localStorage.removeItem(CACHE_KEY);
      localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
      return true;
    } catch {
      return false;
    }
  }
}

export function shouldUpdateLoginSettingsCache(cached, fresh) {
  if (!fresh) return false;
  if (!cached) return true;

  return (
    cached.id !== fresh.id ||
    (cached.updatedAt || "") !== (fresh.updatedAt || "") ||
    cached.logoLight !== fresh.logoLight ||
    cached.logoDark !== fresh.logoDark ||
    cached.siteName !== fresh.siteName
  );
}

/** Aquece o cache do navegador para as imagens das logos. */
export function preloadLogoImages(settings) {
  if (!settings) return;

  [settings.logoLight, settings.logoDark]
    .filter(Boolean)
    .forEach((src) => {
      const img = new Image();
      img.decoding = "async";
      img.src = src;
    });
}
